import axios from 'axios';

import { getProvisionTypes } from '~/redux/api/methods/document';
import { pilot } from '~/services/serviceInstances';

type GetAlertModalDataParams = {
  userClient: string | number;
  alertId?: string | null;
};

type AlertModalDataResponse = {
  customFieldsRes: unknown;
  sections: any;
  provisionOptions: { suggestions: unknown[] };
  alertData?: any;
};

export const getAlert = ({
  userClient,
  alertId,
}: GetAlertModalDataParams): Promise<AlertModalDataResponse> => {
  const requestsArray = [
    pilot.get(`user/${String(userClient)}/list_user_fields/`),
    pilot.get('/alert/sections/'),
    getProvisionTypes(),
  ];

  if (alertId) {
    requestsArray.push(pilot.get(`/alert/${alertId}/`));
  }

  return pilot
    .concurrentRequests(requestsArray)
    .then(
      axios.spread((userFieldsRes, sectionsRes, provisionsRes, alertRes) => ({
        customFieldsRes: userFieldsRes,
        sections: sectionsRes,
        provisionOptions: provisionsRes,
        alertData: alertRes,
      })),
    )
    .catch((err) => {
      throw err;
    });
};
